import React from 'react';

type BadgeVariant =
  | 'active' | 'pending' | 'review' | 'rejected' | 'closed' | 'critical' |'draft'| 'settled' | 'confirmed' | 'failed' | 'low' | 'medium' | 'high' |'kyc-approved' | 'edd' | 'published' | 'warning';

interface StatusBadgeProps {
  variant: BadgeVariant;
  label: string;
  dot?: boolean;
  className?: string;
}

export default function StatusBadge({ variant, label, dot, className = '' }: StatusBadgeProps) {
  return (
    <span className={`status-badge badge-${variant} ${className}`}>
      {dot && <span className="w-1.5 h-1.5 rounded-full bg-current" />}
      {label}
    </span>
  );
}